import React, { createContext, useContext } from "react";
import { joinPath } from "./routedOverlayUtils";

const RoutedOverlayBaseContext = createContext<string | undefined>(undefined);

/**
 * Sets the base pathname that descendant routed overlays resolve against.
 * Pass `path` for an absolute base, or `segment` to append to the parent base.
 * With `segment` and no parent base, descendants stay unrouted.
 */
export function RoutedOverlayBase({
  path,
  segment,
  children,
}: Readonly<{
  path?: string | null;
  segment?: string;
  children: React.ReactNode;
}>) {
  const parent = useContext(RoutedOverlayBaseContext);
  let value: string | undefined;
  if (path !== undefined) {
    value = path === null ? undefined : joinPath(path);
  } else if (parent !== undefined) {
    value = segment ? joinPath(parent, segment) : parent;
  }

  return (
    <RoutedOverlayBaseContext.Provider value={value}>
      {children}
    </RoutedOverlayBaseContext.Provider>
  );
}

export const useRoutedOverlayBase = (): string | undefined =>
  useContext(RoutedOverlayBaseContext);
